import { IAddUpdateCustomPageRequest } from "../../../../model/admin-portal/request/add-update-custom-page-request";
import { ICustomPagesListRequest } from "../../../../model/admin-portal/request/custom-pages-list-request";
import { ICustomPageListResponse } from "../../../../model/admin-portal/response/custom-page-list-response";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type PaginasCustomizadasState = {
    dataPaginatedListResponse: PaginationResponse<ICustomPageListResponse>;
    isLoadingData: boolean;
    dataSearchRequest: ICustomPagesListRequest;
    dataResponse: ICustomPageListResponse | null;
    dataRequest: IAddUpdateCustomPageRequest;
    showAddEdit: boolean;
    filesMap: Map<string, File | null>;
};

export const initialState: PaginasCustomizadasState = {
    dataPaginatedListResponse: new PaginationResponse<ICustomPageListResponse>(),
    isLoadingData: false,
    dataSearchRequest: {
        page: 0,
        pageSize: 10,
        term: '',
        published: null
    },
    dataResponse: null,
    dataRequest: {
        id: null,
        title: '',
        metaDescription: '',
        metaKeywords: '',
        publicationDate: new Date(),
        published: true,
        order: null,
        sections: [
            {
                id: null,
                type: 1,
                title: '',
                content: '',
                url: '',
                imageFileName: '',
                order: 1,
                items: [],
                file: null
            }
        ]
    },
    showAddEdit: false,
    filesMap: new Map<string, File>()
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataSearchRequest = 'setDataSearchRequest',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setFileForSection = 'setFileForSection',
    setFileForItem = 'setFileForItem',
    clearFilesMap = 'clearFilesMap',
    removeFileForSection = 'removeFileForSection',
    removeFileForItem = 'removeFileForItem'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<ICustomPageListResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ICustomPagesListRequest }
    | { type: ACTION_TYPES.setDataResponse; payload: ICustomPageListResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateCustomPageRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setFileForSection; payload: { sectionIndex: number; file: File | null } }
    | { type: ACTION_TYPES.setFileForItem; payload: { sectionIndex: number; itemIndex: number; file: File | null } }
    | { type: ACTION_TYPES.clearFilesMap }
    | { type: ACTION_TYPES.removeFileForSection; payload: { sectionIndex: number } }
    | { type: ACTION_TYPES.removeFileForItem; payload: { sectionIndex: number; itemIndex: number } };

export const paginasCustomizadasReducer = (state: PaginasCustomizadasState, action: Action): PaginasCustomizadasState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };

        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };

        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };

        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };

        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };

        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };

        case ACTION_TYPES.setFileForSection: {
            const newFilesMap = new Map(state.filesMap);
            newFilesMap.set(`section-${action.payload.sectionIndex}`, action.payload.file);
            return { ...state, filesMap: newFilesMap };
        }

        case ACTION_TYPES.setFileForItem: {
            const newFilesMap = new Map(state.filesMap);
            newFilesMap.set(`section-${action.payload.sectionIndex}-item-${action.payload.itemIndex}`, action.payload.file);
            return { ...state, filesMap: newFilesMap };
        }

        case ACTION_TYPES.clearFilesMap:
            return { ...state, filesMap: new Map<string, File | null>() };

        case ACTION_TYPES.removeFileForSection: {
            const newFilesMap = new Map(state.filesMap);
            newFilesMap.delete(`section-${action.payload.sectionIndex}`);
            return { ...state, filesMap: newFilesMap };
        }

        case ACTION_TYPES.removeFileForItem: {
            const newFilesMap = new Map(state.filesMap);
            newFilesMap.delete(`section-${action.payload.sectionIndex}-item-${action.payload.itemIndex}`);
            return { ...state, filesMap: newFilesMap };
        }

        default:
            return state;
    }
};
